import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

/**
 * Detects language from URL prefix (/fr, /es) and sets it in context.
 */
export const LanguageDetector = () => {
  const { setLanguage } = useLanguage();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/fr')) {
      setLanguage('fr');
    } else if (path.startsWith('/es')) {
      setLanguage('es');
    }
  }, [location.pathname, setLanguage]);

  return null;
};

export default LanguageDetector;
